export default {
  get (options) {
    if (!options.routeName)
      throw new Error('Missing required param `routeName`')

    const request = Kadenze.AjaxRequest(this._getRequestOptions(options, 'GET'))

    if (options.done)
      request.done(options.done)

    if (options.fail)
      request.fail(options.fail)

    return request
  },

  post (options) {
    if (!options.routeName)
      throw new Error('Missing required param `routeName`')

    const request = Kadenze.AjaxRequest(this._getRequestOptions(options, 'POST'))

    if (options.done)
      request.done(options.done)

    if (options.fail)
      request.fail(options.fail)

    return request
  },

  delete (options) {
    options.url = this._getRoute(options)

    const $element = options.$element
    const url = options.url || $element.attr('href')
    const $parent = options.$parent || $element.parents('tr, .js-delete-parent')

    const request = Kadenze.AjaxRequest({
      url,
      type: 'DELETE',
      data: options.data || {},
    })

    request.done(data => {
      $parent.remove()

      new Kadenze.Notice.success({ message: data.message })

      if (options.done)
        options.done(data)

      if (data.redirect)
        Kadenze.Request.pjax({ url: data.redirect })
    })

    request.fail(data => {
      new Kadenze.Notice.error({ message: data.message })
    })
  },

  _getRequestOptions (options, type) {
    const url = this._getRoute(options)

    const requestOpts = { url, type }

    if (options.dataType)
      requestOpts.dataType = options.dataType

    if (options.dataAsJSON)
      requestOpts.dataAsJSON = options.dataAsJSON

    if (options.data)
      requestOpts.data = options.data

    if (options.loadingContainer)
      requestOpts.loadingIndicator = { container: options.loadingContainer }

    if (options.timeout)
      requestOpts.timeout = options.timeout

    if (options.progressBar)
      requestOpts.progressBar = options.progressBar

    return requestOpts
  },

  _getRoute(options) {
    if (options.url) {
      return options.url
    } else if (options.routeName) {
      const routeParams = [].concat(options.routeParams)

      const routeName = options.routeName.match(/_(?:path|url)$/) ?
        options.routeName :
        `${options.routeName}_path`

      return Kadenze.Routes[routeName](...routeParams)
    } else {
      return;
    }
  },
}
